import { useEffect, useMemo, useState } from "react";
import {
  APP_LANGUAGE_EVENT,
  loadAppLanguage,
  t as tKey,
} from "utils/appLanguage";

export default function useAppLanguage() {
  const [language, setLanguage] = useState(() => loadAppLanguage());

  useEffect(() => {
    const onLang = () => setLanguage(loadAppLanguage());
    window.addEventListener(APP_LANGUAGE_EVENT, onLang);
    return () => window.removeEventListener(APP_LANGUAGE_EVENT, onLang);
  }, []);

  const t = useMemo(() => (key) => tKey(key, language.id), [language.id]);
  return { language, languageId: language.id, t };
}
